type ScrollBehavior = "auto" | "smooth" | "instant";

export function getScrollContainer(el: HTMLElement | null): HTMLElement | null {
    if (el == null || el.tagName === "HTML") return null;
    const overflow = window.getComputedStyle(el).getPropertyValue("overflow-y");
    if (overflow === "scroll" || overflow === "auto") {
        return el;
    } else {
        return getScrollContainer(el.parentElement);
    }
}

export function getScrollPosition(el: Element | null): number {
    const container = getScrollContainer(el);
    return container == null ? window.scrollY : container.scrollTop;
}

export function scroll(
    el: Element,
    options: {
        top?: number;
        left?: number;
        behavior?: ScrollBehavior;
    }
) {
    const container = getScrollContainer(el);
    if (container == null) {
        window.scroll(options);
    } else {
        container.scroll(options);
    }
}

export function scrollToTop(
    el: Element,
    options: { behavior?: ScrollBehavior } = {}
) {
    scroll(el, { top: 0, ...options });
}

export function scrollToBottom(
    el: Element,
    options: { behavior?: ScrollBehavior } = {}
) {
    scroll(el, { top: 99999, ...options }); // TODO: ちゃんと計算する
}

export function isBottom(el: Element, asobi = 0) {
    const container = getScrollContainer(el);
    const current = container
        ? el.scrollTop + el.offsetHeight
        : window.scrollY + window.innerHeight;
    const max = container ? el.scrollHeight : document.body.offsetHeight;
    return current >= max - asobi;
}
